import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";


function CinqQuestionsAcheteur() {
  return (
    <section class=" flex flex-row flex-wrap justify-center items-center bg-slate-100">
                <div className="py-14 sm:py-20 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="text-3xl font-bold tracking-tight leading-10 text-gray-900 sm:text-4xl">
                                <span className="font-bold text-indigo-800">Achat immobilier chez le notaire</span>
                                : 5 informations importantes</h2>

                        </div>
                        <div className="mt-10 lg:col-span-7 lg:mt-0 sm:max-w-[60%] mx-auto">
                            <dl className="space-y-10">
                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Qu'est-ce que les frais de notaire en immobilier ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    Les frais de notaire sont les coûts que vous payez au notaire lors de l’achat de votre achat immobiler. <br/>
                                    Voici ce que contiennent les frais de notaire : 
                                    <ul>
                                        <li>• les taxes (droits d’enregistrement ou de mutation), </li>
                                        <li>• les débours (frais avancés par le notaire pour des documents administratifs)</li>
                                        <li>• les émoluments (rémunération du notaire)</li>
                                    </ul>
                                    Les montants sont fixés par la loi et dépendent de la valeur de ce que vous achetez. 
                                    <br/>Vous souhaitez calculer vos frais de notaire ? <Link to="#" className="text-indigo-800 font-bold">Calculez vos frais de notaire</Link>
                                    <br/>Pour mieux comprendre vos frais de notaire : <Link to="/immobilier/notaire/de-quoi-se-compose-les-frais-de-notaire" className="text-indigo-800 font-bold">Comprendre les frais de notaire</Link>

                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Qui paye les frais de notaire ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    C'est généralement l'acheteur qui paye les frais de notaire.
                                    
                                    <br/>Pour mieux comprendre vos frais de notaire : <Link to="/immobilier/notaire/de-quoi-se-compose-les-frais-de-notaire" className="text-indigo-800 font-bold">Comprendre les frais de notaire</Link>

                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Les frais de notaire sont-ils négociables ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    Non, les frais de notaire ne sont généralement pas négociables car ils sont réglementés par la loi.
                                    <br/> Cependant, une petite partie des frais, appelée les émoluments de formalités, peut être discutée. La majorité des frais couvre les taxes et contributions obligatoires à l’État, donc ils restent fixes.
                                    <br/> Il existe quelques astuces pour réduire vos frais de notaire : <Link to="https://clotere.framer.website/blog/astuces-pour-r%C3%A9duire-vos-frais-de-notaire-lors-d-un-achat-immobilier" className="text-indigo-800 font-bold" target="blank">Astuces pour réduire vos frais de notaire</Link>
                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Quels sont les délais d'un achat immbobilier ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    Les délais pour finaliser un achat immobilier sont généralement les suivants :
                                    <ul>
                                        <li className="font-semibold">1. Signature du compromis ou de la promesse de vente : 1 à 2 semaines après accord.</li>
                                        <li className="font-semibold">2. Délai de rétractation : 10 jours pour l’acheteur.</li>
                                        <li className="font-semibold">3. Obtention du financement : 30 à 60 jours pour valider le prêt.</li>
                                        <li className="font-semibold">4. Signature de l’acte authentique chez le notaire : Environ 3 mois après le compromis.</li>
                                    </ul>
                                    Ces délais peuvent varier selon la complexité de la transaction ou la disponibilité des parties impliquées.
                                    </dd>
                                </div>

                                <div className="bg-white my-4 rounded-lg p-4">
                                    <dt className="text-lg font-semibold leading-7 ">
                                        Quels documents dois-je fournir au notaire pour l'achat d'un bien immobilier ?
                                    </dt>
                                    <dd className="mt-2 text-md leading-7 text-gray-600">
                                    Pour acheter un bien immobilier, voici les principaux documents que vous devrez fournir :
                                        <ul>
                                            <li className="font-bold">1. Pièce d’identité (carte d’identité ou passeport).</li>
                                            <li className="font-bold">2. Justificatif de domicile.</li>
                                            <li className="font-bold">3. Justificatifs financiers : Relevés bancaires, Bulletins de salaire ou justificatif de revenus, Avis d’imposition.</li>
                                            <li className="font-bold">4. Documents liés au financement : Accord de prêt bancaire (si applicable).</li>
                                            <li className="font-bold">5. Informations personnelles : Livret de famille (si nécessaire).</li>
                                        </ul>
                                        Ces documents peuvent varier selon votre situation et le type d’achat. En remplissant quelques informations, Clotere vous donne la liste exacte des documents nécessaire à votre passage chez le notaire.
                                        
                                    </dd>
                                </div>

                            </dl>
                        </div>


                    </div>
                    <div className="mx-auto text-center container">
                        <p className="text-lg"> Débutez aujourd'hui votre dossier chez le notaire</p>
                        <Link to="/onboard/achat"
                            type="button"
                            className="btn-indigo p-6  no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm w-auto"
                        >
                            Trouver mon notaire acheteur
                            <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                        </Link>
                    </div>

                </div>

            </section>
  );
}

export default CinqQuestionsAcheteur;